import { DevTool } from "@hookform/devtools";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Autocomplete,
  Button,
  Card,
  CircularProgress,
  Modal,
  TextField,
  Typography,
  Avatar,
  Badge,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import SnackBarUI from "../../common/SnackUI";
import { addPaymentRequestAction } from "../../redux/toolkit/payments/add-payment-request";
import { paymentRequestListAction } from "../../redux/toolkit/payments/payment-request-lists";
import { bankListAction } from "../../redux/toolkit/accountDetail.jsx/banklist";
import { uplodImageAction } from "../../redux/toolkit/image/uploadImage";

// schema
const catSchema = yup
  .object()
  .shape({
    invoice_verification_receipt: yup
      .string()
      .required("Invoice verification receipt is required."),
  })
  .required();

export default function CreateCategory({ state, setState, dateData }) {
  // state
  const {
    register,
    setValue,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = useForm({ resolver: yupResolver(catSchema) });

  const dispatch = useDispatch();
  const createCat = useSelector((state) => state.addPayment);
  const { status, message, loading } = createCat;
  const [snack, setSnack] = useState(false);
  const [bankId, setBankId] = useState();
  const [invoice_verification_receipt, setInvoiceVerificationReceipt] =
    useState("");
  const bankList = useSelector((state) => state.listBank);
  const { status: bankStatus, data: bankData, loading: bankLoading } = bankList;
  const filteredObjects = bankData.filter((obj) => obj?.is_verified !== 0);
  // fn

  useEffect(() => {
    dispatch(bankListAction());
  }, [dispatch]);

  const handleCategory = async (data) => {
    data.bank_id = bankId;
    data.month = dateData?._id?.month;
    data.year = dateData?._id?.year;
    data.amount = dateData?.totalEarningsWithBonus;
    const createCategoryData = await dispatch(addPaymentRequestAction(data));
    if (createCategoryData?.payload?.status == 200) {
      await dispatch(paymentRequestListAction({ is_deleted: "" }));
    }
    setSnack(true);
    setState(false);
    reset();
    setInvoiceVerificationReceipt("");
  };

  const handleIconUpload2 = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      console.error("No file selected");
      return;
    }
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
    ];
    if (!allowedTypes.includes(file.type)) {
      alert("Only images (PNG, JPG) and PDFs are allowed!");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    try {
      let uploadedFile = await dispatch(uplodImageAction(formData));
      const fileUrl = uploadedFile?.payload?.data?.url;

      setInvoiceVerificationReceipt(fileUrl);

      setValue("invoice_verification_receipt", fileUrl, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    } catch (error) {
      console.error("File upload failed:", error);
    }
  };

  const handleClose = function () {
    setState(false);
    setInvoiceVerificationReceipt("");
  };

  return (
    <>
      {/* <Modal style={{ display: "flex", alignItems: "center", justifyContent: "center" }} sx={{ overflow: 'scroll' }} open={state} onClose={handleClose}>
                <Box className='modal_box'>
                    <Card sx={{ width: 400, p: 5 }}>
                        <Typography variant='h5' sx={{ mb: 5 }} align='center'>Create Payment Request</Typography>
                        <form onSubmit={handleSubmit(handleCategory)}>
                            <Stack spacing={3}>
                                <Autocomplete
                                    disablePortal
                                    //   multiple
                                    //   aria-multiline
                                    options={filteredObjects}
                                    getOptionLabel={(option) => option?.branch} // Specify the property to display as the option label
                                    onChange={(event, value) => {
                                        setBankId(value?._id)
                                        setValue('bank_id', value?._id, {
                                            shouldValidate: true,
                                            shouldDirty: true,
                                            shouldTouch: true,
                                        }
                                        )
                                    }}
                                    //   sx={{ width: 450 }}
                                    renderInput={(params) => <TextField {...params} error={errors?.bank_id?.message} helperText={errors?.bank_id?.message} label="select Bank" />}
                                />

                                <Stack spacing={3} direction={"row"}>
                                    <TextField
                                        inputProps={{ accept: "image/*,application/pdf" }}
                                        InputLabelProps={{ shrink: true }}
                                        error={!!errors?.invoice_verification_receipt}
                                        helperText={errors?.invoice_verification_receipt?.message}
                                        label="Invoice Verification Receipt"
                                        type="file"
                                        id="invoice_verification_receipt"
                                        onChange={handleIconUpload2}
                                        style={{ width: "50%" }}
                                    />
                                      { invoice_verification_receipt &&  <Button
                                            color="primary"
                                            variant="contained"
                                            onClick={() => {
                                                window.open(invoice_verification_receipt);
                                            }}
                                        >
                                            Download
                                        </Button>}
                                </Stack>

                                <Stack direction='row' spacing={2}>
                                    <Button variant='contained' type='submit' disabled={loading}>{loading ? <CircularProgress /> : 'Add Request'}</Button>
                                    <Button variant='contained' color='error' onClick={handleClose}>Close</Button>
                                </Stack>
                            </Stack>
                        </form>
                    </Card>
                </Box>
            </Modal> */}

      <Modal
        open={state}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
          overflow: "scroll",
          p: 2,
          zIndex:999999
        }}
      >
        <Box className="modal_box">
          <Card sx={{ width: { xs: "90%", sm: 400 }, p: { xs: 3, sm: 5 } }}>
            <Typography variant="h5" sx={{ mb: 5 }} align="center">
              Create Payment Request
            </Typography>

            <form onSubmit={handleSubmit(handleCategory)}>
              <Stack spacing={3}>
                {/* Bank Select */}
                <Autocomplete
                  disablePortal
                  options={filteredObjects}
                  getOptionLabel={(option) => option?.branch || ""}
                  onChange={(event, value) => {
                    setBankId(value?._id);
                    setValue("bank_id", value?._id, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={!!errors?.bank_id}
                      helperText={errors?.bank_id?.message}
                      label="Select Bank"
                    />
                  )}
                />

                {/* File Upload + Download Button */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  alignItems="center"
                >
                  <TextField
                    inputProps={{ accept: "image/*,application/pdf" }}
                    InputLabelProps={{ shrink: true }}
                    error={!!errors?.invoice_verification_receipt}
                    helperText={errors?.invoice_verification_receipt?.message}
                    label="Invoice Verification Receipt"
                    type="file"
                    id="invoice_verification_receipt"
                    onChange={handleIconUpload2}
                    sx={{ width: "100%" }}
                  />

                  {invoice_verification_receipt && (
                    <Button
                      variant="contained"
                      onClick={() => window.open(invoice_verification_receipt)}
                      sx={{
                        mt: { xs: 1, sm: 0 },
                        width: { xs: "100%", sm: "auto" },
                      }}
                    >
                      Download
                    </Button>
                  )}
                </Stack>

                {/* Buttons */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={loading}
                    sx={{ width: { xs: "100%", sm: "auto" } }}
                  >
                    {loading ? <CircularProgress size={24} /> : "Add Request"}
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleClose}
                    sx={{ width: { xs: "100%", sm: "auto" } }}
                  >
                    Close
                  </Button>
                </Stack>
              </Stack>
            </form>
          </Card>
        </Box>
      </Modal>

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
      <DevTool control={control} />
    </>
  );
}

CreateCategory.propTypes = {
  state: PropTypes.any,
  setState: PropTypes.any,
};
